import React, { useState, useEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
} from "../Shared/Utility";
import { useGlobalState } from "../Context/GlobalStateContext";
import { useSearchParams } from "react-router-dom";

function GeneralData() {
  const globalState = useGlobalState();
  const [searchParams] = useSearchParams();
  const [isAnimation, setIsAnimation] = useState(false);

  const [GeneralDataLists, setGeneralDataLists] = useState<any[]>([]);
  const [GeneralDataHeader, setGeneralDataHeader] = useState<any[]>([]);
  const [GeneralData, setGeneralData] = useState<any[]>([]);
  const [SelectedKeyName, setSelectedKeyName] = useState<string>("");
  const [TypeID, setTypeID] = useState<number>(0);

  useEffect(() => {
    GetGeneralDataFiltersData();
  }, []);

  const GetGeneralDataFiltersData = () => {
    axiosAuth
      .get(AppContext.APIURL + "api/SiteUser/GetGeneralDataFiltersData")
      .then((res) => {
        setGeneralDataLists(res.data[0]);
      })
      .catch((err) => console.error(err));
  };

  const GetGeneralData = () => {
    const data: any = {};
    data.TypeID = TypeID;

    // Find SelectedKeyName
    const selectedItem = GeneralDataLists.find((x) => x.PID === TypeID);
    if (selectedItem) {
      setSelectedKeyName(selectedItem.Name);
    }

    setIsAnimation(true);

    setGeneralData([]);
    setGeneralDataHeader([]);

    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/GetGeneralData", data)
      .then((res) => {
        setIsAnimation(false);
        setGeneralDataHeader(res.data[0]);
        setGeneralData(res.data[1]);
      })
      .catch((err) => {
        setIsAnimation(false);
        console.error(err);
      });
  };

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <>
        <div className="flex-d justify-btw mb-10">
          <div className="flex-da flex-gap10">
            <div className="field-input">
              <select
                value={TypeID}
                onChange={(e) => setTypeID(Number(e.target.value))}
                className="input-field input-select"
              >
                <option value="0">Select</option>
                {GeneralDataLists.map((item) => (
                  <option key={item.PID} value={item.PID}>
                    {item.Name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex-daj btn-start">
              <a onClick={GetGeneralData} className="btn-primary flex-daj">
                Get Data
              </a>
            </div>
          </div>
          <span className="flex-d font-mont bold-font c-theme">
            {SelectedKeyName}
          </span>
          <div className="flex-daj flex-gap10">
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcel("tblpages", "General Data")
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
        </div>
        <div className="flow-auto-sm">
          <table className="reuse-table first-left" id="tblpages">
            <thead>
              <tr>
                {GeneralDataHeader.map((col, i) => (
                  <th key={i}>{col.Name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {GeneralData.map((item, rowIndex) => (
                <tr key={rowIndex}>
                  {GeneralDataHeader.map((col, colIndex) => (
                    <td key={colIndex} className="text-right">
                      {item[col.Name]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    </div>
  );
}

export default GeneralData;
